import { Button } from 'antd'
import React from 'react'

function LoadingButton({children}) {
  return (
    <Button loading className='auf-button'>{children}</Button>
  )
}

export default LoadingButton